package com.example.mystybag.appCore.model.pages

/**
 * UI state for the Filter results bottom sheet.
 * Values can be wired to HomePageViewModel filters later.
 */
data class FilterResultsUIState(
    val useMyLocation: Boolean = true,
    val distanceKm: Float = 20f,
    /** Selected merchant location ID (obekt). null = no filter by location (all locations). */
    val selectedLocationId: Long? = null,
    val priceMin: String = "",
    val priceMax: String = "",
    val selectedRatingIndex: Int = 0, // 0 = none, 1 = 3.0+, 2 = 4.0+, 3 = 4.5+
    val selectedPublishedDateIndex: Int = 0, // 0 = Today, 1 = Last 3 days, 2 = This week, 3 = This month
    val selectedCollectionTimeIndex: Int = 0 // 0 = none, 1 = Available now, 2 = 08:00-12:00, 3 = 12:00-17:00, 4 = Evening
) {
    companion object {
        val default: FilterResultsUIState get() = FilterResultsUIState()
    }

    /** Types of filters that can be shown as chips and cleared individually. */
    enum class ActiveFilterType { DISTANCE, RATING, PRICE, LOCATION, PUBLISHED_DATE, COLLECTION_TIME }

    /** Returns which filter dimensions are non-default (active). */
    fun activeFilterTypes(): List<ActiveFilterType> = buildList {
        if (distanceKm != default.distanceKm) add(ActiveFilterType.DISTANCE)
        if (selectedRatingIndex != 0) add(ActiveFilterType.RATING)
        if (priceMin != default.priceMin || priceMax != default.priceMax) add(ActiveFilterType.PRICE)
        if (selectedLocationId != null) add(ActiveFilterType.LOCATION)
        if (selectedPublishedDateIndex != 0) add(ActiveFilterType.PUBLISHED_DATE)
        if (selectedCollectionTimeIndex != 0) add(ActiveFilterType.COLLECTION_TIME)
    }
}
